import React from 'react'
import SectionTitle from './SectionTitle'

interface SkillCategoryProps {
    title: string
    skills: string[]
}

function SkillCategory({ title, skills }: SkillCategoryProps) {
    return (
        <div className="print-avoid-break bg-white rounded-lg border border-neutral-200 p-4 shadow-sm w-full md:flex-1 md:w-auto min-w-0">
            <h3 className="font-display font-medium text-sm text-primary uppercase tracking-wide mb-3">
                {title}
            </h3>
            <div className="flex flex-wrap gap-1.5">
                {skills.map((skill, index) => (
                    <span
                        key={index}
                        className="px-2 py-1 bg-neutral-100 text-neutral-600 text-xs font-body rounded"
                    >
                        {skill}
                    </span>
                ))}
            </div>
        </div>
    )
}

export default function Skills() {
    const skillCategories = [
        {
            title: "Cloud & DevOps",
            skills: [
                "AWS", "Terraform", "AWS CDK", "ECS Fargate", "Lambda", "Docker",
                "CI/CD", "DevSecOps", "Datadog", "Zero-Downtime Migrations",
                "Security & Compliance", "Cost Optimization"
            ]
        },
        {
            title: "Development & Data",
            skills: [
                "TypeScript", "Python", "JavaScript", "Java", "React", "Node.js",
                "Data Engineering", "ETL/ELT", "Airflow", "Windmill", "Spark",
                "RAG", "OpenAI APIs", "Claude APIs"
            ]
        },
        {
            title: "Leadership",
            skills: [
                "Engineering Management", "People Management", "Team Scaling",
                "Hiring & Interviewing", "Mentorship", "Fractional CTO",
                "Agile", "Scrum", "Architecture Reviews"
            ]
        }
    ]

    return (
        <section>
            <SectionTitle title="Skills" />
            <div className="mt-4 flex flex-wrap justify-between gap-4">
                {skillCategories.map((category, index) => (
                    <SkillCategory
                        key={index}
                        title={category.title}
                        skills={category.skills}
                    />
                ))}
            </div>
        </section>
    )
}
